(function() {

var _ = ui._;
ui.afterSessionInitAdd = afterSessionInitAdd;
ui.ajax                = ajax;
ui.click               = click;
ui.descriptionToggle   = descriptionToggle;
ui.hashClear           = hashClear;
ui.hashCode            = hashCode;
ui.hrefPrepare         = hrefPrepare;
ui.loadAdd             = loadAdd;
ui.notifyMe            = notifyMe;
ui.numberFormat        = numberFormat;
ui.paymentClick        = paymentClick;
ui.paymentClose        = paymentClose;
ui.postData            = postData;
ui.priceFormat         = priceFormat;
ui.sizeFormat          = sizeFormat;
ui.weightFormat        = weightFormat;

ui.localStorage = storageCreate('localStorage');
ui.sessionStorage = storageCreate('sessionStorage');

loadAdd(onLoad);
svgInline2();

//w.addEventListener('beforeinstallprompt', appButton);
w.addEventListener('error', errorLog);
var appEvent, $appBtn;
var afterSessionInitFuncs = [];

function onLoad(event) {
  if(location.href.indexOf('/admin/') === -1)
    sessionInit();
}

function ajax(method, url, data, onSuccess, onError, headers, faderShow) {
  function onload(event) {
    if(request.readyState !== 4)
      return;
    try {
      if(request.status === 200)
        onSuccess && onSuccess(request);
      else {
        var messageShown = false;
        if(request.status === 202) {
          var res = JSON.parse(request.responseText);
          for(var i = 0; i < res.errors.length; i++)
            ui.messageShow(res.errors[i], 'error', false);
          messageShown = true;
        }
        if(onError)
          onError(request);
        else
        if(!messageShown && request.responseText && (request.responseText.indexOf('<!DOCTYPE html>') === -1))
          ui.messageShow(request.responseText, 'error');
      }
    } finally {
      ajax.openedURLs.splice(ajax.openedURLs.indexOf(url), 1);
      ui.faderHide && ui.faderHide();
    }
  }

  if(!ajax.openedURLs)
    ajax.openedURLs = [];
  if(ajax.openedURLs.indexOf(url) !== -1) {
    console.log('already started url ' + url);
    setTimeout(ajax, 100, method, url, data, onSuccess, onError, headers, faderShow);
    return;
  }

  ajax.openedURLs.push(url);
  try {
    var request = new XMLHttpRequest();
    request.open(method, url);
    if(headers)
      for(var header in headers)
        request.setRequestHeader(header, headers[header]);
    request.setRequestHeader('X-Referer', location.href);
    request.onreadystatechange = onload;
    request.withCredentials = true;
    request.send(data);
    if(faderShow === undefined)
      faderShow = true;
    faderShow && ui.faderShow && ui.faderShow();
    return true;
  } catch(e) {
    ajax.openedURLs.splice(ajax.openedURLs.indexOf(url), 1);
  }
}

function afterSessionInitAdd(func) {
  if(afterSessionInitFuncs === undefined)
    func();
  else
    afterSessionInitFuncs.push(func);
}

function appButton(event) {
  appEvent = event;
  ui.appInstall = appInstall;
  ui.appModal = appModal;
  _(d.body).append(
    $appBtn = _('div').attr('class', 'app-install-btn', 'onclick', 'ui.appModal(event)').text(ui.lang.text_app_btn)
  );
}

function appInstall(event) {
  if(!appEvent)
    return;
  appEvent.prompt().then(function(result) {
    appEvent = null;
    $appBtn.toggleClass('hidden', true);
    delete ui.appInstall;
    delete ui.appModal;
    ui.modalClose();
  });
}

function appModal(event) {
  if(!appEvent)
    return;
  var $he = _('div').attr('class', 'app-modal-box').append(
    _('div').html(ui.lang.text_app_desc),
    _('button').attr('onclick', 'ui.appInstall(event)', 'class', 'app-modal-btn').text(ui.lang.text_app_btn)
  );
  ui.modalOpenHE($he, ui.lang.text_app_btn);
}

function click(ident) {
  _(ident).el.click();
}

function descriptionToggle(event) {
  var he = event.currentTarget.parentElement.parentElement;
  he.classList.toggle('description-compact');
  he.scrollIntoView();
}

var errorLogStarted = false;

function errorLog(event) {
  function success() {
    errorLogStarted = false;
  }
  if(errorLogStarted)
    return;
  var data = {
    message: event.message,
    stack: event.error.stack,
    url: location.href
  }
  ajax('POST', ui.hostm + '/errorlog', JSON.stringify(data), success, success);
  errorLogStarted = true;
}

function hashClear() {
  history.replaceState(null, null, ' ');
}

function hashCode(str) {
  var hash = 0, i, chr;
  for(i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

function hrefPrepare(event, filter) {
  var $he = _(event.target).parentTo('a');
  if($he.el.href.indexOf('#') === -1)
    $he.el.href += '#filter=' + filter;
}

function loadAdd(func) {
  if(d.readyState === 'loading')
    w.addEventListener('DOMContentLoaded', func);
  else
    func();
}

function notifyMe(event, product_id) {
  event.preventDefault();
  var INPUT_CLS = 'w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand focus:border-transparent transition-all text-sm placeholder:text-gray-400';
  var LABEL_CLS = 'block text-xs font-bold text-gray-700 mb-1.5 uppercase tracking-wide';
  var he = _('div').append(
    _('form').attr('class', 'notify-form').append(
      _('input').attr('type', 'hidden', 'name', 'product_id', 'value', product_id),
      _('div').attr('class', 'p-6 space-y-5 text-sm').append(
        _('div').append(
          _('label').attr('class', LABEL_CLS).html(ui.lang.text_name + ' <span class="text-red-500">*</span>'),
          _('input').attr('type', 'text', 'name', 'name', 'required', 'true', 'minlength', '2', 'maxlength', '32', 'class', INPUT_CLS)
        ),
        _('div').append(
          _('label').attr('class', LABEL_CLS).html(ui.lang.text_email + ' <span class="text-red-500">*</span>'),
          _('input').attr('type', 'email', 'name', 'email', 'required', 'true', 'minlength', '3', 'maxlength', '50', 'class', INPUT_CLS)
        ),
        _('div').append(
          _('label').attr('class', LABEL_CLS).text(ui.lang.text_comment),
          _('textarea').attr('name', 'message', 'rows', '4', 'maxlength', '1000', 'class', INPUT_CLS + ' resize-none')
        )
      ),
      _('div').attr('class', 'p-5 border-t border-gray-100 bg-gray-50 flex justify-end gap-3').append(
        _('button').attr('type', 'button', 'class', 'h-11 px-6 text-sm font-bold uppercase tracking-wide border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 rounded-md', 'onclick', 'ui.modalClose()').text(ui.lang.text_close),
        _('button').attr('type', 'button', 'class', 'h-11 px-8 text-sm font-bold uppercase tracking-wide bg-brand text-brand-text rounded-md shadow-md active:scale-95 transition-transform', 'onclick', 'ui.postData(event, ui.url.notifyMe)').text(ui.lang.text_notify_button)
      )
    )
  );
  ui.modalOpenHE(he, ui.lang.text_notify_me);
}

function numberFormat(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function paymentClick(event) {
  event.preventDefault();
  event.stopPropagation();
  var $he = _(event.target).parentTo('svg');
  var type = $he.attrGet('data');
  if(type && ui.lang[type + '_description']) {
    ui.tooltipShow({target: $he.el}, ui.lang[type + '_description'], 'tooltip-box-product', 'paymentClose');
    var children = event.currentTarget.children, type2;
    for(var i = 0; i < children.length; i++) {
      $he = _(children[i]);
      type2 = $he.attrGet('data');
      if(type2)
        $he.toggleClass('payment-icon-disabled', type2 !== type);
    }
  }
}

function paymentClose($he) {
  var parent = $he.parent().el;
  for(var i = 0; i < parent.children.length; i++)
    _(parent.children[i]).toggleClass('payment-icon-disabled', false);
}

function postData(event, url) {
  function valuesGet() {
    var form = event.currentTarget.form;
    var values = [];
    var value;
    var isValid = true;
    for(var i = 0; i < form.length; i++) {
      if((!form[i].name) || ((form[i].type === 'radio') && !form[i].checked))
        continue;
      var errEl = form[i].parentNode.querySelector('.input-error-msg');
      if(form[i].validity.valid) {
        form[i].classList.remove('input-error');
        if(errEl) errEl.remove();
        values.push(form[i].name + '=' + form[i].value);
      } else {
        form[i].classList.add('input-error');
        var v = form[i].validity;
        var msg = v.valueMissing ? (ui.lang.text_val_required || 'Обов\'язкове поле')
          : v.tooShort ? (ui.lang.text_val_min || 'Мінімум %s символів').replace('%s', form[i].minLength)
          : v.tooLong ? (ui.lang.text_val_max || 'Максимум %s символів').replace('%s', form[i].maxLength)
          : v.typeMismatch ? (ui.lang.text_val_format || 'Невірний формат')
          : (ui.lang.text_val_value || 'Невірне значення');
        if(errEl) {
          errEl.textContent = msg;
        } else {
          var span = document.createElement('div');
          span.className = 'input-error-msg';
          span.textContent = msg;
          form[i].parentNode.appendChild(span);
        }
        isValid = false;
      }
    }
    if(isValid)
      return values.join('&');
  }

  function onSend(request) {
    var json = JSON.parse(request.responseText);
    ui.messageShow(json.message, 'success');
    ui.modalClose();
  }

  event.preventDefault();
  var values = valuesGet();
  if(values)
    ajax('POST', url, values, onSend, null, {'Content-Type': 'application/x-www-form-urlencoded'});
}

function priceFormat(price) {
  return numberFormat(price) + ' ' + ui.lang.text_currency_unit;
}

function sessionInit() {
  function onInit(request) {
    ui.session_data = JSON.parse(request.responseText);
    if(ui.session_data.quickedit) {
      _(d.body).append(_('div').html(ui.session_data.quickedit));
      delete ui.session_data.quickedit;
    }

    for(var i = 0; i < afterSessionInitFuncs.length; i++)
      afterSessionInitFuncs[i]();
    afterSessionInitFuncs = undefined;
  }

  if(ui.url)
    ajax('POST', ui.url.sessionInit, '', onInit, null, null, false);
}

function sizeFormat(size) {
  if(size < 1024)
    return size + ' Bytes';
  if(size < 1024 * 1024)
    return Math.round(size / 1024, 2) + ' KB';
  if(size < 1024 * 1024 * 1024)
    return Math.round(size / 1024 / 1024, 2) + ' MB';
  return Math.round(size / 1024 / 1024 / 1024, 2) + ' GB';
}

function storageCreate(name) {
  function clear() {
    if(storage)
      storage.clear();
    else
      memory = {};
  }

  function getItem(key) {
    return storage ? storage.getItem(key) : memory[key] || null;
  }

  function removeItem(key) {
    if(storage)
      storage.removeItem(key);
    else
      delete memory[key];
  }

  function setItem(key, value) {
    if(storage)
      storage.setItem(key, value);
    else
      memory[key] = String(value);
  }

  var memory = {};
  var storage;

  try {
    storage = w[name];
    storage.setItem('__storage_test__', '1');
    storage.removeItem('__storage_test__');
  } catch(e) {
    storage = null;
  }

  return {
    clear: clear,
    getItem: getItem,
    removeItem: removeItem,
    setItem: setItem,
  };
}

function svgInline2() {
  if(ui.svg)
    _('div').attr('class', 'hidden').appendTo(_(d.body)).html(ui.svg);
}

function weightFormat(weight) {
  return numberFormat(weight) + ' ' + ui.lang.text_weight_unit;
}
})();

(function() {

var _ = ui._;
if(ui.modals)
  for(var i = 0, l = ui.modals.length, name; i < l; i++) {
    name = ui.modals[i];
    ui[name + '_show'] = open.bind(null, name);
  }

function open(name, event) {
  if(event)
    event.preventDefault();
  if(ui.modalIsOpened())
    return;
  var $frag = _('frag').append(
    _('div').attr('class', 'prose prose-zinc max-w-none text-gray-700 leading-relaxed font-medium space-y-6').html(ui.lang[name + '_description']),
    _('div').attr('class', 'modal-buttons').append(
      _('span').attr('class', 'modal-button', 'onclick', 'ui.modalClose()').text(ui.lang.text_close)
    )
  );
  ui.modalOpenHE($frag, ui.lang[name + '_title']);
}

if(ui.info_cashback_modal_show)
  ui.info_cashback_modal_show = openCashback;

function openCashback(event) {
  if(event)
    event.preventDefault();
  if(ui.modalIsOpened())
    return;

  var SVG_X = '<svg class="w-6 h-6 text-neutral-400 group-hover:rotate-90 transition-transform" aria-hidden="true"><use href="#svg-icon-x"/></svg>';
  var SVG_USER_PLUS = '<svg width="20" height="20" aria-hidden="true"><use href="#svg-icon-user-plus"/></svg>';
  var SVG_CAMERA = '<svg width="20" height="20" aria-hidden="true"><use href="#svg-icon-camera"/></svg>';
  var SVG_AT = '<svg width="20" height="20" aria-hidden="true"><use href="#svg-icon-at-sign"/></svg>';
  var SVG_VIDEO = '<svg width="24" height="24" aria-hidden="true"><use href="#svg-icon-video2"/></svg>';
  var SVG_INFO = '<svg width="20" height="20" class="text-neutral-900 mt-0.5" aria-hidden="true"><use href="#svg-icon-info"/></svg>';
  var SVG_CHECK = '<svg width="16" height="16" class="text-neutral-400" aria-hidden="true"><use href="#svg-icon-circle-check"/></svg>';
  var SVG_INSTAGRAM = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-instagram-line"/></svg>';
  var SVG_PHONE_ICON = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-phone-call"/></svg>';
  var SVG_TIKTOK = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-smartphone"/></svg>';

  var L = ui.lang;
  var hotlineHE = d.querySelector('.binct-phone-number-1');
  var hotlineText = hotlineHE ? hotlineHE.textContent.trim() : '';
  var hotlineHref = hotlineText ? hotlineText.replace(/\s+/g, '-') : '';

  var tiers = [
    [L.text_cashback_tier_1 || 'до 5 000 грн',          '200 ₴',  '400 ₴'],
    [L.text_cashback_tier_2 || '5 001 – 10 000 грн',     '300 ₴',  '600 ₴'],
    [L.text_cashback_tier_3 || '10 001 – 15 000 грн',    '400 ₴',  '800 ₴'],
    [L.text_cashback_tier_4 || '15 001 – 20 000 грн',    '500 ₴',  '1000 ₴'],
    [L.text_cashback_tier_5 || 'від 20 001 грн',         '600 ₴',  '1200 ₴']
  ];
  var tableRows = '';
  for(var t = 0; t < tiers.length; t++)
    tableRows += '<tr class="hover:bg-neutral-50 transition-colors">' +
      '<td class="px-6 py-4 text-neutral-900 font-black text-sm">' + tiers[t][0] + '</td>' +
      '<td class="px-6 py-4 text-center text-neutral-500 font-bold text-sm">' + tiers[t][1] + '</td>' +
      '<td class="px-6 py-4 text-center text-black font-black text-sm bg-brand/10 italic">' + tiers[t][2] + '</td>' +
    '</tr>';

  var stepHTML = function(icon, text) {
    return '<div class="flex items-start gap-4 group">' +
      '<div class="flex-shrink-0 w-10 h-10 rounded-lg bg-neutral-900 flex items-center justify-center text-brand group-hover:scale-110 transition-transform">' + icon + '</div>' +
      '<p class="text-neutral-800 text-sm font-bold pt-2 leading-relaxed m-0">' + text + '</p>' +
    '</div>';
  };

  var socials = '';
  if(ui.instagram)
    socials += '<a href="https://instagram.com/' + ui.instagram + '" target="_blank" rel="noopener" class="flex items-center gap-2 text-neutral-400 hover:text-brand-hover transition-colors no-underline">' + SVG_INSTAGRAM + '<span class="text-xs font-black tracking-tight uppercase">@' + ui.instagram + '</span></a>';
  if(ui.tiktok)
    socials += '<a href="' + ui.tiktok + '" target="_blank" rel="noopener" class="flex items-center gap-2 text-neutral-400 hover:text-black transition-colors no-underline">' + SVG_TIKTOK + '<span class="text-xs font-black tracking-tight uppercase">TikTok</span></a>';
  if(hotlineText)
    socials += '<a href="tel:' + hotlineHref + '" class="flex items-center gap-2 text-neutral-400 hover:text-black transition-colors no-underline">' + SVG_PHONE_ICON + '<span class="text-xs font-black tracking-tight">' + hotlineText + '</span></a>';

  var html =
    '<div class="cashback-modal-card relative">' +
      '<button type="button" onclick="ui.modalClose()" aria-label="Close" class="absolute top-5 right-5 p-2 hover:bg-neutral-800 hover:text-white rounded-full transition-all z-20 group bg-transparent border-0 cursor-pointer">' + SVG_X + '</button>' +
      '<div class="bg-neutral-900 p-8 text-white relative overflow-hidden border-b-4 border-brand">' +
        '<div class="absolute -right-10 -top-10 w-40 h-40 bg-brand rounded-full blur-3xl opacity-10"></div>' +
        '<div class="flex items-center gap-2 mb-4"><span class="bg-brand text-brand-text text-[10px] font-black px-2 py-1 rounded-sm tracking-tighter uppercase">' + (L.text_cashback_brand || 'Besport Bonus') + '</span></div>' +
        '<h2 class="text-3xl font-black leading-tight tracking-tight uppercase italic m-0">' + (L.text_cashback_title || 'Отримайте кешбек') + ' <br><span class="text-brand">' + (L.text_cashback_title_accent || 'за ваш відгук!') + '</span></h2>' +
        '<p class="mt-3 text-neutral-400 text-sm max-w-md mb-0">' + (L.text_cashback_intro || 'Поділіться враженнями в Instagram або Tik Tok та отримайте до 1200 грн на картку.') + '</p>' +
      '</div>' +
      '<div class="p-8">' +
        '<div class="mb-10">' +
          '<h3 class="text-xs font-black text-neutral-400 uppercase tracking-widest mb-6 flex items-center gap-2 m-0"><span class="w-8 h-[2px] bg-brand"></span>' + (L.text_cashback_steps || 'Що потрібно зробити') + '</h3>' +
          '<div class="grid gap-5">' +
            stepHTML(SVG_USER_PLUS, L.text_cashback_step_1 || 'Підпишіться на наш профіль в Instagram або Tik Tok') +
            stepHTML(SVG_CAMERA,    L.text_cashback_step_2 || 'Зробіть фото або відеоогляд з придбаним товаром') +
            stepHTML(SVG_AT,        L.text_cashback_step_3 || 'Тегніть нашу сторінку у дописі або сторіс') +
          '</div>' +
        '</div>' +
        '<div class="mb-8 p-5 bg-brand rounded-xl text-brand-text flex items-center justify-between shadow-lg">' +
          '<div class="flex items-center gap-4">' +
            '<div class="bg-black text-brand p-3 rounded-lg shadow-inner">' + SVG_VIDEO + '</div>' +
            '<div>' +
              '<p class="text-[10px] font-black uppercase leading-none mb-1 opacity-70">' + (L.text_cashback_special_label || 'Спецпропозиція') + '</p>' +
              '<h4 class="text-xl font-black uppercase italic tracking-tighter m-0">' + (L.text_cashback_special_title || 'Кешбек подвоюється!') + '</h4>' +
            '</div>' +
          '</div>' +
          '<div class="text-right hidden sm:block border-l border-black/20 pl-4">' +
            '<p class="text-[10px] uppercase font-black opacity-70 mb-0">' + (L.text_cashback_video_eq || 'Відеоогляд =') + '</p>' +
            '<p class="text-xl font-black leading-none tracking-tighter mb-0">' + (L.text_cashback_video_x2 || 'x2 БОНУС') + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="mb-10">' +
          '<div class="overflow-hidden rounded-xl border-2 border-neutral-100">' +
            '<table class="w-full text-left border-collapse">' +
              '<thead class="bg-neutral-900 text-brand text-[10px] uppercase tracking-widest"><tr>' +
                '<th class="px-6 py-4 font-black">' + (L.text_cashback_col_orders || 'Сума замовлення') + '</th>' +
                '<th class="px-6 py-4 font-black text-center">' + (L.text_cashback_col_photo || 'Фото / Відгук') + '</th>' +
                '<th class="px-6 py-4 font-black text-center bg-brand text-brand-text">' + (L.text_cashback_col_video || 'Відеоогляд') + '</th>' +
              '</tr></thead>' +
              '<tbody class="divide-y divide-neutral-100">' + tableRows + '</tbody>' +
            '</table>' +
          '</div>' +
        '</div>' +
        '<div class="space-y-3 mb-10">' +
          '<div class="flex gap-3 items-start p-4 bg-neutral-50 rounded-xl border-l-4 border-brand">' + SVG_INFO +
            '<p class="text-[11px] text-neutral-700 leading-relaxed font-bold m-0">' + (L.text_cashback_note_1 || 'Якщо у замовленні більше 1 товару — кешбек рахується на загальну суму за умови оглядів на <span class="underline decoration-brand decoration-2">кожен</span> товар.') + '</p>' +
          '</div>' +
          '<div class="flex gap-3 items-center px-4">' + SVG_CHECK +
            '<p class="text-[11px] text-neutral-500 font-bold m-0">' + (L.text_cashback_note_2 || 'Кешбек не сумується та не переноситься на майбутні покупки.') + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="flex flex-col gap-6">' +
          '<button type="button" onclick="ui.modalClose()" class="w-full bg-black hover:bg-neutral-800 text-brand font-black py-5 rounded-xl transition-all shadow-xl active:scale-[0.98] tracking-[0.2em] text-sm uppercase italic border-0 cursor-pointer">' + (L.text_cashback_accept || 'Прийняти умови') + '</button>' +
          (socials ? '<div class="flex flex-wrap justify-center gap-x-8 gap-y-3">' + socials + '</div>' : '') +
        '</div>' +
      '</div>' +
    '</div>';

  var $wrap = _('div').html(html);
  ui.modalOpenHE(_($wrap.el.firstChild), '');
}

})();

(function() {

var _ = ui._;
function openInfoWide(event, title, body, fallbackTitle, fallbackBody) {
  if(event)
    event.preventDefault();
  if(ui.modalIsOpened())
    return;

  var SVG_X = '<svg class="w-6 h-6 text-neutral-400 group-hover:rotate-90 transition-transform" aria-hidden="true"><use href="#svg-icon-x"/></svg>';

  title = title || fallbackTitle;
  body  = body  || fallbackBody;

  var html =
    '<div class="info-modal-card relative">' +
      '<button type="button" onclick="ui.modalClose()" aria-label="Close" class="absolute top-5 right-5 p-2 hover:bg-neutral-800 hover:text-white rounded-full transition-all z-20 group bg-transparent border-0 cursor-pointer">' + SVG_X + '</button>' +
      '<div class="bg-neutral-900 p-8 text-white relative overflow-hidden border-b-4 border-brand">' +
        '<div class="absolute -right-10 -top-10 w-40 h-40 bg-brand rounded-full blur-3xl opacity-10"></div>' +
        '<h2 class="text-3xl font-black leading-tight tracking-tight uppercase italic m-0">' + title + '</h2>' +
      '</div>' +
      '<div class="p-8">' +
        '<div class="prose prose-zinc max-w-none text-gray-700 leading-relaxed font-medium space-y-6">' + body + '</div>' +
        '<button type="button" onclick="ui.modalClose()" class="mt-8 w-full bg-black hover:bg-neutral-800 text-brand font-black py-5 rounded-xl transition-all shadow-xl active:scale-[0.98] tracking-[0.2em] text-sm uppercase italic border-0 cursor-pointer">' + (ui.lang.text_close || 'Закрити') + '</button>' +
      '</div>' +
    '</div>';

  var $wrap = _('div').html(html);
  ui.modalOpenHE(_($wrap.el.firstChild), '');
}

})();

(function() {

ui.formInit = formInit;
ui.formOnInput2 = formOnInput;
ui.formOnInvalid = formOnInvalid;

function formInit(formHE) {
  for(var i = 0, l = formHE.length, he; i < l; i++) {
    he = formHE[i];
    if(he.hasAttribute('data-invalid')) {
      he.setAttribute('oninvalid', 'ui.formOnInvalid(event)');
      he.setAttribute('oninput', 'ui.formOnInput2(event)');
    }
  }
}

function formOnInput(event) {
  event.target.setCustomValidity('');
}

function formOnInvalid(event) {
  var he = event.target;
  he.setCustomValidity(he.validity.valid ? '' : he.getAttribute('data-invalid'));
}

})();

(function() {

var langIdent = 'lang';
ui.langSet = langSet;
langRedirect();

function langRedirect() {
  if(!ui.localStorage.getItem(langIdent))
    ui.localStorage.setItem(langIdent, ui.langCode);
  var lang = ui.localStorage.getItem(langIdent);
  if(ui.langCode === lang)
    return;
  var links = d.querySelectorAll('link[rel=alternate]');
  for(var i = 0, l = links.length; i < l; i++)
    if(links[i].hreflang.substr(0, 2) === lang)
      location.href = links[i].href.substring(links[i].href.indexOf('/', 9));
}

function langSet(code, url) {
  ui.localStorage.setItem(langIdent, code);
  location.href = url;
}

})();

(function() {

var _ = ui._;
ui.afterSessionInitAdd(init);
ui.wishDelete    = delete_;
ui.wishDeleteAll = deleteAll;
ui.wishShow      = show;
ui.wishToggle    = toggle;

function delete_(event, product_id) {
  function success() {
    var $he = _(event.target).parent();
    while(true)
      if($he.hasClass('wish-product')) {
        $he.remove();
        break;
      } else
        $he = $he.parent();
    if(ui.session_data.wish.length === 0)
      ui.modalClose();
    else {
      var badge = d.getElementById('wish-modal-count');
      if(badge) badge.textContent = ui.session_data.wish.length;
    }
  }
  toggle(event, product_id, success);
}

function deleteAll(event) {
  event.preventDefault();
  event.stopPropagation();
  ui.ajax('GET', ui.url.wishClear, null, function() {
    ui.session_data.wish = [];
    countShow();
    ui.modalClose();
  });
}

function init() {
  countShow();
  for(var i = 0; i < ui.session_data.wish.length; i++)
    mark(ui.session_data.wish[i], true);
}

function countShow() {
  var c = ui.session_data.wish.length;
  _('#wish-product-count').text(c);
  _('#wish-product-count-mobile').text(c);
}

function mark(product_id, added) {
  var hes = _(d.body).elsByClass('wish-' + product_id);
  for(var i = 0; i < hes.length; i++)
    _(hes[i]).toggleClass('product-wish-icon-filled', added);
}

function show(event) {
  if(!(ui.session_data.wish && ui.session_data.wish.length))
    return;

  var SVG_X = '<svg width="24" height="24" aria-hidden="true"><use href="#svg-icon-x"/></svg>';
  var SVG_TRASH = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-trash"/></svg>';
  var SVG_CART = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-cart-solid"/></svg>';
  var SVG_BELL = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-bell"/></svg>';
  var SVG_CHEVRON_RIGHT = '<svg width="16" height="16" aria-hidden="true"><use href="#svg-icon-chevron-right"/></svg>';

  function productHTML(product) {
    if(!product)
      return '';
    var priceHTML = product.instock
      ? '<span class="text-lg font-black text-gray-900 leading-none">' + ui.priceFormat(product.saleprice) + '</span>' +
        (product.price_old && product.price_old > product.saleprice ? '<span class="text-xs text-gray-400 line-through mt-1">' + ui.priceFormat(product.price_old) + '</span>' : '')
      : '<span class="text-[10px] font-bold text-gray-400 uppercase">' + ui.lang.text_not_in_stock_btn + '</span>';
    var buyAction = product.instock ? 'ui.cartUI.add' : 'ui.notifyMe';
    var buyIcon = product.instock ? SVG_CART : SVG_BELL;
    var titleSafe = (product.title || '').replace(/"/g, '&quot;');
    return '<div class="wish-product wish-modal-item p-5 flex gap-4 hover:bg-gray-50 transition-colors group">' +
      '<a href="' + product.href + '" class="w-20 h-20 flex-shrink-0 bg-white border border-gray-100 rounded-xl p-1 flex items-center justify-center">' +
        '<img src="' + product.image + '" alt="' + titleSafe + '" class="max-w-full max-h-full object-contain">' +
      '</a>' +
      '<div class="flex-grow min-w-0">' +
        '<a href="' + product.href + '" class="block text-sm font-bold leading-tight mb-2 line-clamp-2 hover:text-brand transition-colors text-gray-800 no-underline">' + product.title + '</a>' +
        '<div class="flex items-center justify-between gap-2">' +
          '<div class="flex flex-col">' + priceHTML + '</div>' +
          '<div class="wish-modal-actions flex gap-1.5">' +
            '<button type="button" title="' + ui.lang.button_delete + '" class="w-9 h-9 bg-gray-100 hover:bg-red-50 text-gray-400 hover:text-red-500 rounded-xl flex items-center justify-center transition-colors border-0 cursor-pointer" onclick="ui.wishDelete(event, ' + product.product_id + ')">' + SVG_TRASH + '</button>' +
            (product.instock
              ? '<span class="flex" data-cart-btn="' + product.product_id + '">' +
                  '<button type="button" class="cart-add-only w-9 h-9 bg-brand hover:bg-brand-hover text-brand-text rounded-xl flex items-center justify-center shadow-sm border-0 cursor-pointer" onclick="ui.cartUI.add(event, ' + product.product_id + ')">' + SVG_CART + '</button>' +
                  '<button type="button" class="cart-in-cart-only !hidden w-9 h-9 cart-mini-incart rounded-xl flex items-center justify-center shadow-sm border-0 cursor-pointer" onclick="ui.cartUI.update(true)">' + SVG_CART + '</button>' +
                '</span>'
              : '<button type="button" class="w-9 h-9 bg-brand hover:bg-brand-hover text-brand-text rounded-xl flex items-center justify-center shadow-sm border-0 cursor-pointer" onclick="' + buyAction + '(event, ' + product.product_id + ')">' + buyIcon + '</button>'
            ) +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  var productsHTML = '';
  for(var i = 0; i < ui.session_data.wish.length; i++)
    productsHTML += productHTML(ui.productGet(ui.session_data.wish[i]));

  var continueText = ui.lang.button_continue_select || ui.lang.button_shopping;
  var drawerHTML =
    '<div class="wish-modal-drawer">' +
      '<div class="wish-modal-header p-6 border-b border-gray-100 flex items-center justify-between">' +
        '<div class="flex items-center gap-3">' +
          '<h2 class="text-xl font-extrabold uppercase tracking-tight italic m-0">' + ui.lang.text_wish_products + '</h2>' +
          '<span id="wish-modal-count" class="bg-brand text-brand-text text-[10px] font-black px-2 py-0.5 rounded-full leading-none">' + ui.session_data.wish.length + '</span>' +
        '</div>' +
        '<button type="button" onclick="ui.modalClose()" class="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-black bg-transparent border-0 cursor-pointer" aria-label="Close">' + SVG_X + '</button>' +
      '</div>' +
      '<div class="wish-modal-body flex-grow overflow-y-auto custom-scrollbar"><div class="divide-y divide-gray-50">' + productsHTML + '</div></div>' +
      '<div class="wish-modal-footer p-6 bg-gray-50 border-t border-gray-100">' +
        '<div class="flex gap-3">' +
          '<button type="button" onclick="ui.wishDeleteAll(event)" class="flex-1 border border-gray-200 hover:bg-white text-gray-500 hover:text-red-600 font-bold py-3 px-4 rounded-xl text-xs uppercase tracking-wider transition-all flex items-center justify-center gap-2 bg-transparent cursor-pointer">' +
            SVG_TRASH + (ui.lang.button_delete_all || 'Очистити') +
          '</button>' +
          '<button type="button" onclick="ui.modalClose()" class="flex-[2] bg-black text-brand font-black py-3 px-4 rounded-xl text-xs uppercase tracking-widest hover:bg-zinc-800 transition-all flex items-center justify-center gap-2 shadow-lg border-0 cursor-pointer">' +
            '<span>' + continueText + '</span>' + SVG_CHEVRON_RIGHT +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';

  var $drawer = _('div').html(drawerHTML);
  ui.modalOpenHE(_($drawer.el.firstChild), ui.lang.text_wish_products);
  if(ui.cartUI && ui.cartUI.update)
    ui.cartUI.update(false);
}

function toggle(event, product_id, after) {
  function success(request) {
    var obj = JSON.parse(request.responseText);
    var index = ui.session_data.wish.indexOf(product_id);
    if(index !== -1)
      ui.session_data.wish.splice(index, 1);
    if(obj.added)
      ui.session_data.wish.unshift(product_id);
    countShow();
    mark(product_id, obj.added);
    after && after();
  }
  event.preventDefault();
  event.stopPropagation();
  ui.ajax('GET', ui.url.wishToggle + '?product_id=' + product_id, null, success);
}

})();

(function() {

var _ = ui._;
ui.scroll = scroll;
ui.loadAdd(onLoad);

function onLoad() {
  var hes = _(d).elsByClass('scroll-v-list');
  for(var i = 0; i < hes.length; i++)
    _(hes[i]).on('touchstart', touchStart).on('touchmove', touchMove).on('touchend', touchEnd);
}

function scroll(id, isLeft) {
  function validate() {
    var styles = getComputedStyle(list);
    if(styles.position !== 'relative')
      throw new Error('scroll: container ' + id + ' should have position relative');
    if(styles.fontSize !== '0px')
      throw new Error('scroll: container ' + id + ' should have font-size 0 ' + +styles.fontSize);
  }

  function visibleCountGet() {
    if(isSingle)
      return 1;

    var lengthName    = isY ? 'height' : 'width';
    var listRect      = list.getBoundingClientRect();
    var itemRect      = itemCur.getBoundingClientRect();
    var length        = itemRect[lengthName];
    var lengthVisible = listRect[lengthName];
    return Math.trunc(lengthVisible / length);
  }

  function indexGet() {
    var indexCustom = $list.attrGet('data-index-custom');
    if(indexCustom) {
      $list.attr('data-index-custom', '');
      return indexCustom;
    }
    var indexLast = count - visibleCountGet();
    if(indexLast < 0)
      indexLast = 0;
    var index = indexCur + (isLeft ? -1 : 1);
    if(index < 0)
      index = indexLast;
    else if(index > indexLast)
      index = 0;
    return index;
  }

  var $list    = _('#' + id);
  var list     = $list.el;
  validate();
  var isY      = $list.attrGet('data-axis') === 'Y';
  var isSingle = $list.attrGet('data-single') === '1';
  var after    = $list.attrGet('data-after');
  var indexCur = +$list.attrGet('data-index');
  var count    = list.children.length;
  var itemCur  = list.children[indexCur];
  var index    = indexGet();
  var item     = list.children[index];
  var options  = {behavior: 'smooth'};
  if(isY)
    options.top = item.offsetTop;
  else
    options.left = item.offsetLeft;
  list.scroll(options);
  $list.attr('data-index', index);
  if(after)
    ui[after](list, indexCur, index);
}

function touchEnd(event) {
  var he = event.currentTarget;
  _(he).attrR('data-scrollX')
    .attrR('data-startX')
    .attr('data-index-custom', Math.round(he.scrollLeft / he.children[0].scrollWidth));
  scroll(he.id, true);
}

function touchMove(event) {
  event.preventDefault();
  event.stopPropagation();
  var he = event.currentTarget;
  var scrollX = +he.getAttribute('data-scrollX');
  var startX = +he.getAttribute('data-startX');
  he.scrollLeft = scrollX - event.changedTouches[0].clientX + startX;
}

function touchStart(event) {
  var he = event.currentTarget;
  he.setAttribute('data-scrollX', he.scrollLeft);
  he.setAttribute('data-startX',  event.changedTouches[0].clientX);
}

})();